import { render, staticRenderFns } from "./study_deduct_score.vue?vue&type=template&id=a448aa80&scoped=true"
import script from "./study_deduct_score.vue?vue&type=script&lang=js"
export * from "./study_deduct_score.vue?vue&type=script&lang=js"
import style0 from "./study_deduct_score.vue?vue&type=style&index=0&id=a448aa80&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a448aa80",
  null
  
)

export default component.exports